module.exports = __webpack_public_path__ + "static/media/whatsapp.7611f024.png";